<template>
  <div class="infinite-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
    style="overflow:auto;bodrer:1px solid #e43" infinite-scroll-distance="1">

    <div class="content" v-loading="fullscreenLoading">
      <div class="wraper_bg wallet">
        <div class="info">
          <div class="info_photo">
            <img :src="userinfo.img_url" alt="">
          </div>
          <div class="info_name">
            <p class="info_name_call">
              {{userinfo.wx_name?userinfo.wx_name:userinfo.name}}
            </p>
            <p class="info_name_uid">uid:{{userinfo.id}}</p>
          </div>
          <div class="info_balance">
            <div class="router-link" @click="rechargemoney">
              余额充值
            </div>
          </div>
        </div>
        <div class="info_under">
          <div class="info_under_price divide-line right-border">
            <h3 class="info_id">{{userinfo.count?userinfo.count:0}}</h3>
            <p>余额</p>
          </div>
          <div class="info_under_card divide-line none">
            <h3 class="info_id">6</h3>
            <p>卡券</p>
          </div>
          <div class="info_under_recharge none">
            <h3 class="info_id">180</h3>
            <p>积分</p>
          </div>
        </div>
      </div>

      <div class="wallet_list">
        <div class="wallet_title">
          交易明细
          <div class="wallet_condition">近三个月</div>
        </div>

        <div class="wallet_list_item" v-for="(n,nindex) in lists">
          <div class="wallet_info">
            <div :class="[n.type?'icome':'expenditure','wallet_list_item_type']">{{n.type?'支出':'收入'}}</div>
            <div class="wallet_list_item_number">{{n.type?'-':'+'}}₱{{n.price}}</div>
          </div>
          <div class="wallet_other">
            <div class="wallet_list_item_date">
              {{n.date}}
            </div>
            <div class="wallet_list_item_balance">
              交易后余额：{{n.balance}}
            </div>
          </div>
        </div>
        <p id="loadMore" v-show="droping">加载中...</p>
        <p id="loadMore" v-show="noMore">没有更多了</p>
      </div>

      <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
        <div>
          <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
            :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <navBar :idx="3"></navBar>
    </div>
  </div>

</template>
<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import navBar from '@/components/navBar';
  import vueQr from 'vue-qr'

  export default {
    name: 'wallet',
    components: {
      navBar,
      vueQr
    },
    data() {
      return {
        fullscreenLoading: false,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        userinfo: {},
        busy: false,
        droping: false,
        noMore: false,
        lists: [],
        page: 0,
        pageSize: 10,
      }
    },
    mounted() {
      this.getUserInfo();
    },
    methods: {
      handleClose: function(done) {
        done();
      },
      goBack() {
      },
      loadMore() {
        this.busy = true;
        this.droping = true;
        let auth_token = localStorage.getItem('auth_token');
        if (auth_token) {
          this.page++;
          this.$api
            .request('Member/getBalanceRecords', {page: this.page, pageSize: this.pageSize})
            .then(({ data }) => {
              if (data.length <= 0 || data.length < this.pageSize) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
              data.forEach(item => {
                this.lists.push(item);
              });
              this.busy = false;
              this.droping = false;
            })
            .catch(error => {
              this.$message({
                message: error + "加载充值记录失败！",
                type: "warning"
              })
            });
        } else {
          this.busy = false;
          this.droping = false;
          this.noMore = true;
        }
      },
      getUserInfo() {
        this.$api
          .request('Member/getInfo', {})
          .then(({ data }) => {
            this.userinfo = data;
          })
          .catch(error => {
            this.$message({
              message: error+"获取用户信息失败！",
              type: "warning"
            })
          });
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      rechargemoney() {
        this.$prompt('', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: "请输入充值金额（₱）",
          center: true,
          inputPattern: /^[0-9]*[1-9][0-9]*$/,
          inputErrorMessage: '只能充值整数'
        }).then(({value}) => {
          this.$api
            .request('Order/create', {type:2, client: this.$client, amount: value})
            .then(({ data }) => {
              switch(this.$client) {
               case 'h5':
                  switch (data.type) {
                    case "1":
                      this.downloadData.url = data.result.data.content;
                      break;
                    case "2":
                      this.downloadData.url = data.result.results.qrcode;
                      break;
                    default:
                      this.$message({
                        message: "暂不支持的支付类型！",
                        type: "warning"
                      })
                      break;
                  }
                  this.centerDialogVisible = true;
                  delay(() => {
                    this.checkorder(data.result.results.out_trade_no)
                  }, 3000)
                  break;
               case 'wxh5':
                  switch (data.type) {
                    case "1":
                      let params = JSON.parse(data.result.data.content);
                      this.wxpay(params);
                      break;
                    case "2":
                      window.location.href = data.result.results.api_url;
                      break;
                    default:
                      this.$message({
                        message: "暂不支持的支付类型！",
                        type: "warning"
                      })
                      break;
                  }
                  break;
               case 'magapp':
                  this.magpay(data.result);
                  break;
               default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            })
            .catch(error => {
              this.$message({
                message: error+"下单失败,请联系客服！",
                type: "warning"
              })
            });
        }).catch(() => {
        });
        return;
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
    }
  }
</script>


<style scoped lang="less">
  @import url("../../static/less/mine.less");

  .none {
    display: none !important;
  }

  .info_under .divide-line::after {
    border-right: rgba(0, 0, 0, 0) !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/wallet.vue